<template>
  <div class="row pg_sec">
    <div class="col-12 sec_content">
      <div class="row">
        <div class="col-12 gph_sec ace_sec" aria-label="Chart">
          <div class="bar_chart_container bar_label_inside chart_age_breakdown">
            <template v-for="(item, index) in data">
              <div class="row bar_row ace_sec">
                <div class="col-12">

                  <div class="bar_container clickable" :id="'popover_' + index"  @click="navigateToCareer(item)">
                     <div class="bar_label">{{ item.name }} </div>
                     <div class="bar_val"><span v-html="formatDecimalValue(item.growthDoubleFormat)"></span>% </div>
                     <div class="bar" v-bind:style="{width:item.growthDoubleFormat + '%'}"></div>
                  </div>

                  <div id="chartToolTip" class="chart_tooltip_popover"></div>

                  <b-popover :target="'popover_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="chartToolTip">
                    <div class="tooltip_row">
                      <div class="val">{{ item.name }}</div>
                    </div>
                    <div class="tooltip_row">
                      <div class="label">Growth Rate</div>
                      <div class="val"><span v-html="formatDecimalValue(item.growthDoubleFormat)"></span>% </div>
                    </div>
                  </b-popover>

                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'fastestGrowingCareersList',
  props: ['title', 'data'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadList()
  },

  methods: {
    loadList () {
    },
    navigateToCareer (career) {
      if (!career.code) {
        return this.notifyFailure(this.navigationErrorMessage)
      }
      let routerParams = {
        code: career.pragyaSoc,
        returnTo: 'exploreCareerResults',
        showBackToResultButton: true
      }
      return this.$router.push({ name: 'careerDetail', params: routerParams, query: {returnTo: 'exploreInsightList'} })
    },
    formatDecimalValue (numValue) {
      return parseFloat(numValue).toFixed(2)
    }
  },

  computed: {
  },

  watch: {
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/app/explore/components/FastestGrowingCareersList.vue